/*
This context will be used to provide "overflow" information to children as 
needed. This is currently used to handle the shadows when a stickyHeader is 
also applied to Table. The provider value is set in the OverfloWrapper
component.
*/
import React from "react";
export const Context = /*#__PURE__*/React.createContext({});